import {
  CLEAR_FLAGS_PARAMETROS_INTEGRACAO,
  GET_PARAMETROS_INTEGRACAO_INIT,
  GET_PARAMETROS_INTEGRACAO_SUCCESS,
  ERROR_PARAMETROS_INTEGRACAO_MSG,
  UPDATE_PARAMETROS_INTEGRACAO_INIT,
  UPDATE_PARAMETROS_INTEGRACAO_SUCCESS,
  VALIDAR_DADOS_PGLOADER_INIT,
  VALIDAR_DADOS_PGLOADER_SUCCESS
} from '../../actionTypes';

const INIT_STATE = {
  isUpdated: false,
  isError: false,
  loading: false,
  parametrosIntegracao: null,
  isSuccess: false,
  msg: '',
  isValidating: false,
  isValidated: false,
  validacaoMsg: '',
  dadosValidacaoPgloader: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PARAMETROS_INTEGRACAO_INIT:
      return { ...state, loading: true, isSuccess: false, parametrosIntegracao: null };

    case GET_PARAMETROS_INTEGRACAO_SUCCESS: {
      const { parametrosIntegracao } = action.payload;
      return { ...state, loading: false, isSuccess: true, parametrosIntegracao };
    }
    case UPDATE_PARAMETROS_INTEGRACAO_INIT:
      return {
        ...state,
        isUpdated: false
      };
    case UPDATE_PARAMETROS_INTEGRACAO_SUCCESS: {
      const { msg } = action.payload;
      return {
        ...state,
        msg,
        isUpdated: true
      };
    }
    case VALIDAR_DADOS_PGLOADER_INIT:
      return {
        ...state,
        isValidating: true,
        isValidated: false,
        validacaoMsg: '',
        dadosValidacaoPgloader: []
      };
    case VALIDAR_DADOS_PGLOADER_SUCCESS: {
      const { msg, dados } = action.payload;
      return {
        ...state,
        isValidating: false,
        isValidated: true,
        validacaoMsg: msg,
        dadosValidacaoPgloader: dados || []
      };
    }
    case ERROR_PARAMETROS_INTEGRACAO_MSG: {
      const { msg } = action.payload;
      return {
        ...state,
        isUpdated: false,
        isValidating: false,
        msg,
        isError: true,
        loading: false
      };
    }
    case CLEAR_FLAGS_PARAMETROS_INTEGRACAO: {
      return {
        ...state,
        success: false,
        isUpdated: false,
        isError: false,
        loading: false,
        msg: '',
        isSuccess: false,
        isValidating: false,
        isValidated: false,
        validacaoMsg: '',
        dadosValidacaoPgloader: []
      };
    }

    default:
      return { ...state };
  }
};

